module.exports = __webpack_public_path__ + "img/CFX-logo.0bbae352.png";